<template lang="pug">
  v-layout
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
    v-dialog(v-model="openPopup" persistent width="385")
      v-card
        v-card-text
          v-layout(column style="margin-bottom: 2em")
            v-flex(style="position: absolute;top: 0;right: 0;")
              v-btn(icon @click="closePopup")
                v-icon(color="#0855C4") close
            v-flex.box-titulo-pop-comprobante
              span(style="font-size: 18px;font-weight:600") {{ tituloComprobanteElectronico || 'Comprobante electrónico ' }}
            v-flex.box-elements
              v-layout(column align-center)
                v-flex(style="margin: 0.3em ;" v-for="(item, index) in comprobantesFormatter" :key="index")
                  TarjetaFechaDescarga(
                    style="width: 16em ;height: 2.7em; :"
                    @downloadMethod="downloadComprobanteElectronico(item.tipoDocumento, item.serie, item.correlativo, item.historico)"
                    :textProp="item.fechaEmision"
                    :iconDescarga="iconDescarga"
                    )
            //- v-flex(style="margin-top: 1em ;" v-if="poliza.nombreProducto !== 'VIDACASH'")
              v-layout(column align-center)
                span(style="text-align: center;width:95%") Si deseas descargar tus comprobantes anteriores
                  br
                  span al 2019, solicítalo por nuestro&nbsp;
                  a(:href="links.Chat" target="_blank")
                    b chat web
</template>

<script>
import TarjetaFechaDescarga from './../generic/TarjetaFechaDescarga.vue'
import { mapActions } from 'vuex'

export default {
  props: [
    'openPopup',
    'tituloComprobanteElectronico',
    'textPopupComprobanteElectronico',
    'listaDeComprobantes',
    'iconDescarga',
    'poliza',
    'taggeo'
  ],
  data () {
    return {
      loader: false,
      comprobantesFormatter: [],
      metadata: {}
    }
  },
  mounted () {
    let self = this

    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Comprobante electrónico', metadata: self.metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'ce'
      }
    })
    self.comprobantesFormatter = self.listaDeComprobantes.reverse()
  },
  methods: {
    ...mapActions('user', ['downloadComprobante', 'downloadComprobanteLegacy']),
    ...mapActions('event', ['eventLog']),
    downloadComprobanteElectronico (tipoComprobante, serie, numero, esHistorico) {
      const self = this

      this.loader = true
      let hash = {
        tipoDocumento: tipoComprobante,
        serie: serie,
        correlativo: numero,
        producto: this.poliza.oriProducto || this.poliza.producto,
        grupoProducto: this.poliza.ramo.toUpperCase(),
        numeroPoliza: this.poliza.numeroPoliza
      }
      // TRACK EVENT - GA
      /*
      this.$gtm.trackEvent({
        event: 'Descargas Comprobantes Elec.',
        category: 'Zona Privada',
        action: 'ComprobantesElectronicos',
        label: 'Descarga de Comprobantes Electrónicos'
      })
      */
      // TRACK EVENT - AMPLITUDE
      /* var productoConsultado = ''
      if (this.poliza.oriProducto === null) {
        if (this.poliza.modalidad === null) {
          productoConsultado = this.poliza.producto
        } else {
          productoConsultado = this.poliza.modalidad
        }
      } else {
        productoConsultado = this.poliza.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Comprobantes Electrónicos',
            'Producto Consultado': productoConsultado,
            'Meses consultados': [this.ce.startDate.split('-')[1], this.ce.endDate.split('-')[1]]
          }
        ) */
      const callbackEventLog = (omitEvent) => {
        if (!omitEvent) {
          this.eventLog({
            categoria: 'Documentos',
            nombre: 'Descarga Comprobantes/Boletas',
            datos: hash
          })
        }
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Comprobante',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (esHistorico) {
        hash.Tipo = 'histórico'
        let xml = {
          tipoDoc: serie,
          folio: numero
        }
        this.downloadComprobanteLegacy(xml)
          .then(res => {
            self.loader = false
            hash.Estado = 'Exitoso'
            hash.respuesta = res.data
            callbackEventLog()
          })
          .catch((err) => {
            hash.error = err.response.data
            hash.statusCode = err.response.status
            self.loader = false
            callbackEventLog()
          })
      } else {
        this.downloadComprobante(hash)
          .then((res) => {
            self.loader = false
            callbackEventLog(true)
          })
          .catch((err) => {
            self.loader = false
            if (err.data.codigoRespuesta === '99') {
              self.$swal({
                title: 'Estimado cliente',
                text: 'El Comprobante de Pago Electrónico ' + numero + ' , especificado no está registrado o no se encuentra en estado ACEPTADO.',
                confirmButtonText: 'Entendido'
              })
            } else {
              callbackEventLog(true)
            }
          })
      }
    },
    closePopup () {
      this.$emit('closePopup')
    }
  },
  components: {
    TarjetaFechaDescarga
  }

}
</script>

<style scoped>
.box-comprobante span,
.box-comprobante a {
  color: var(--text-color);
}

.box-titulo-pop-comprobante {
  margin-top: 0.5em;
  margin-left: 0.7em;
  margin-bottom: 1em;
  margin-right: 0.7em;
  text-align: center;
}

.box-elements {
  margin: 0.5em 0em;
  min-height: 14em;
  max-height: 16.7em;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupComprobanteElectronico.vue